import React from "react";
import { motion } from "framer-motion";
import { SectionHeader } from "./About";

export default function Skills({ items }) {
  return (
    <section id="skills" className="py-24 md:py-32 relative border-t border-white/5" data-testid="skills-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <SectionHeader number="04" overline="Stack" title="The control room. Tools across the ML and fintech lifecycle." />
        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {items.map((g, i) => (
            <motion.div
              key={g.id || i}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.35, delay: i * 0.05 }}
              className="bg-ink-900 p-6 min-h-[220px]"
              data-testid={`skill-group-${i}`}
            >
              <p className="overline text-volt mb-3">/ {String(i + 1).padStart(2, "0")}</p>
              <h3 className="font-display font-bold text-lg mb-4">{g.category}</h3>
              <div className="flex flex-wrap gap-1.5">
                {g.items.map((s) => (
                  <span key={s} className="tag-chip">{s}</span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
